export default __webpack_public_path__ + "static/media/surveyIcon.261718eb.svg";